import { useState } from 'react';
import { notification, Popconfirm, Space, Layout } from 'antd';
import { Link } from 'react-router-dom';

import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import CustomButton from '../../../components/CustomButton';
import PdfViewer from '../../../components/PdfViewer';

import { ajaxTable, remove } from '../../../api/module/resume_certifications';
import { get as getDocumentUrl } from '../../../api/module/document_repository';
import { catchException } from '../../../utils/helpers/helpers';
import AjaxTable from '../../../components/AjaxTable';

const { Content } = Layout;

const OtherCertificationsList = ({ idTercero, readOnly }) => {
  const [reloadSource, setReloadSource] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const showClick = async (documento_nombre) => {
    setLoadingDocument(true);
    const response = await getDocumentUrl(documento_nombre);
    setPdfUrl(response.data.url);
    setShowPdf(true);
    setLoadingDocument(false);
  };

  const deleteDataSource = async (id) => {
    try {
      setLoadingDelete(true);
      await remove(id);
      setLoadingDelete(false);
      setReloadSource({});
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
        duration: 2,
      });
    } catch (err) {
      console.log(err);
      setLoadingDelete(false);
      catchException(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    }
  };

  const columns = [
    {
      title: 'Nombre certificación',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Fecha de terminación',
      dataIndex: 'fecha_terminacion',
      key: 'fecha_terminacion',
      align: 'center',
    },
    {
      title: 'Consultar documento',
      dataIndex: 'tarjeta_profesional',
      key: 'tarjeta_profesional',
      fixed: 'right',
      width: 120,
      render: (_text, record) => {
        if (record.documento_nombre) {
          return (
            <CustomButton
              block
              type="default"
              text="Ver"
              htmlType="button"
              loading={loadingDocument}
              onClick={() => {
                showClick(record.documento_nombre);
              }}
            />
          );
        }
      },
    },
    {
      title: 'Acción',
      key: 'accion',
      fixed: 'right',
      width: 200,
      render: (_text, record) =>
        !readOnly ? (
          <Space>
            <CustomButton
              type={'default'}
              className={'ant-btn-info'}
              htmlType="button"
              text={
                <Link
                  to={`${INTERNAL_LINKS.OTHER_CERTIFICATIONS}/${idTercero}/${record.id}`}
                >
                  Editar
                </Link>
              }
            />
            <CustomButton
              danger
              type={'default'}
              htmlType="button"
              loading={loadingDelete}
              text={
                <Popconfirm
                  title={MESSAGES.DELETE_CONFIRM_MSG}
                  onConfirm={() => deleteDataSource(record.id)}
                >
                  Eliminar
                </Popconfirm>
              }
            />
          </Space>
        ) : null,
    },
  ];

  if (!idTercero) {
    return null;
  }

  return (
    <Content>
      <AjaxTable
        columns={columns}
        endpoint={ajaxTable}
        query={idTercero}
        tableTitle="Listado de Otras certificaciones"
        reloadSource={reloadSource}
      />
      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setShowPdf(false)}
        open={showPdf}
      />
    </Content>
  );
};

export default OtherCertificationsList;
